// LIVE.CRASH_SELF_IDENTIFY: client instrumentation. Next runs this on the client
// before the app hydrates, so it is the right place to register the global
// window error hooks. window 'error' and 'unhandledrejection' catch uncaught
// throws and rejected promises that no React boundary sees - the class that
// otherwise lands on the raw __next_error__ screen - and report them through
// the existing fire-and-forget path.
//
// onRecoverableError is intentionally not wired: Next 15.5.18 does not expose it
// as a first-class hook (React sets it only via hydrateRoot options that Next
// owns), so it stays a second-order net. global-error.tsx and these listeners
// are the primary instruments.
import { registerGlobalErrorListeners } from "@/lib/reportClientError";

registerGlobalErrorListeners();
